// Checkout Success Component
// Displays success message and plan details after checkout

import React from 'react';

export function CheckoutSuccess({ sessionData, onGoToAccount, onGoToPricing }) {
  return (
    <div className="checkout-success-content">
      {/* Success Icon */}
      <div className="success-icon">
        <svg
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="12" cy="12" r="10" stroke="#22c55e" strokeWidth="2" fill="rgba(34, 197, 94, 0.1)" />
          <path
            d="M9 12l2 2 4-4"
            stroke="#22c55e"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      {/* Success Message */}
      <h1 className="success-title">Payment Successful!</h1>
      <p className="success-message">
        Thank you for your purchase. Your subscription has been activated.
      </p>

      {/* Plan Details */}
      {sessionData && (
        <div className="plan-details">
          <h3 style={{ color: '#fff', marginBottom: '16px', fontSize: '18px' }}>
            Plan Details
          </h3>
          <div className="detail-row">
            <span className="detail-label">Plan:</span>
            <span className="detail-value">{sessionData.planId?.toUpperCase() || 'N/A'}</span>
          </div>
          {sessionData.tierId && (
            <div className="detail-row">
              <span className="detail-label">Tier:</span>
              <span className="detail-value">{sessionData.tierId}</span>
            </div>
          )}
          {sessionData.billingCycle && (
            <div className="detail-row">
              <span className="detail-label">Billing Cycle:</span>
              <span className="detail-value">
                {sessionData.billingCycle === 'monthly' ? 'Monthly' :
                 sessionData.billingCycle === 'annual' ? 'Annual' :
                 sessionData.billingCycle === 'one-time' ? 'One-time' :
                 sessionData.billingCycle}
              </span>
            </div>
          )}
          {sessionData.price && (
            <div className="detail-row">
              <span className="detail-label">Amount:</span>
              <span className="detail-value">${parseFloat(sessionData.price).toFixed(2)}</span>
            </div>
          )}
          {sessionData.sessionId && (
            <div className="detail-row">
              <span className="detail-label">Session ID:</span>
              <span className="detail-value" style={{ fontFamily: 'monospace', fontSize: '12px' }}>
                {sessionData.sessionId}
              </span>
            </div>
          )}
        </div>
      )}

      {/* Action Buttons */}
      <div className="success-actions">
        <button
          onClick={onGoToAccount}
          className="btn-primary"
        >
          View My Account
        </button>
        <button
          onClick={onGoToPricing}
          className="btn-secondary"
        >
          Back to Pricing
        </button>
      </div>

      {/* Additional Info */}
      <div className="success-info">
        <p style={{ color: '#999', fontSize: '14px', marginTop: '32px' }}>
          You will receive a confirmation email shortly. If you have any questions, please contact support.
        </p>
      </div>
    </div>
  );
}
